/**
 * UNDA — map Kaching free gifts onto €0 "Gratis" SKUs and enforce client
 * incentives: Karabiner from 2 bottles, Kordel from 3 bottles (Favorite = 2
 * → Karabiner only). Loaded on the LP hero and the cart page.
 */
(function () {
  if (window.__undaFreeGiftsBooted) return;
  window.__undaFreeGiftsBooted = true;

  var PAID_GIFT_TO_FREE = {
    '52736582222160': '53484473483600', // Karabiner Black → Gratis
    '51748204872016': '53484473876816' // Kordel Black → Gratis
  };
  var FREE_KARABINER = '53484473483600';
  var FREE_KORDEL = '53484473876816';
  var KORDEL_IDS = {
    '51748204872016': true,
    '53484473876816': true
  };

  function formQuantity(form) {
    var q = form && form.querySelector('[name="quantity"]');
    return Number(q && q.value) || 1;
  }

  function stripKordelGiftFields(form, qty) {
    if (qty >= 3) return;
    var idInputs = form.querySelectorAll('input[name^="items["][name$="[id]"]');
    Array.prototype.forEach.call(idInputs, function (input) {
      var id = String(input.value || '');
      if (!KORDEL_IDS[id] && !KORDEL_IDS[PAID_GIFT_TO_FREE[id]]) return;
      var match = input.name.match(/^items\[(\d+)\]/);
      if (!match) return;
      var prefix = 'items[' + match[1] + ']';
      Array.prototype.forEach.call(form.querySelectorAll('input[name^="' + prefix + '"]'), function (el) {
        el.disabled = true;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    });
  }

  function remapFormDataGifts(fd, qty) {
    if (!fd || typeof fd.get !== 'function') return;
    var keys = [];
    fd.forEach(function (_value, key) {
      if (/^items\[\d+\]\[id\]$/.test(key)) keys.push(key);
    });
    keys.forEach(function (key) {
      var id = String(fd.get(key) || '');
      if (PAID_GIFT_TO_FREE[id]) {
        id = PAID_GIFT_TO_FREE[id];
        fd.set(key, id);
      }
      if (qty < 3 && KORDEL_IDS[id]) {
        var idx = key.match(/^items\[(\d+)\]/);
        if (!idx) return;
        var prefix = 'items[' + idx[1] + ']';
        var toDelete = [];
        fd.forEach(function (_v, k) {
          if (k.indexOf(prefix) === 0) toDelete.push(k);
        });
        toDelete.forEach(function (k) {
          fd.delete(k);
        });
      }
    });
  }

  function installFetchPatch() {
    var nativeFetch = window.fetch;
    if (!nativeFetch || window.__undaFreeGiftFetchPatch) return;
    window.__undaFreeGiftFetchPatch = true;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            var qtyFd = Number(init.body.get('quantity')) || 1;
            remapFormDataGifts(init.body, qtyFd);
          } else if (typeof init.body === 'string') {
            try {
              var parsed = JSON.parse(init.body);
              if (parsed && Array.isArray(parsed.items)) {
                var mainQty = 1;
                parsed.items.forEach(function (item) {
                  if (item.properties && item.properties.__kaching_bundles) {
                    try {
                      var meta = JSON.parse(item.properties.__kaching_bundles);
                      if (meta && meta.main === true) mainQty = Number(item.quantity) || mainQty;
                    } catch (e) {}
                  }
                });
                parsed.items = parsed.items
                  .map(function (item) {
                    var freeId = PAID_GIFT_TO_FREE[String(item.id || '')];
                    if (freeId) item = Object.assign({}, item, { id: freeId });
                    return item;
                  })
                  .filter(function (item) {
                    if (mainQty < 3 && KORDEL_IDS[String(item.id)]) return false;
                    return true;
                  });
                init = Object.assign({}, init, { body: JSON.stringify(parsed) });
              }
            } catch (e) {}
          }
        }
      } catch (e2) {}
      return nativeFetch.call(this, input, init).then(function (response) {
        try {
          var u = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/add/.test(u)) setTimeout(ensureFreeGifts, 500);
        } catch (e3) {}
        return response;
      });
    };
  }

  function installFormPatch() {
    if (window.__undaFreeGiftFormPatch) return;
    window.__undaFreeGiftFormPatch = true;
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
        try {
          var qty = formQuantity(form);
          var inputs = form.querySelectorAll('input[name^="items["][name$="[id]"]');
          Array.prototype.forEach.call(inputs, function (input) {
            var freeId = PAID_GIFT_TO_FREE[String(input.value)];
            if (freeId) input.value = freeId;
          });
          stripKordelGiftFields(form, qty);
        } catch (e) {}
      },
      true
    );
  }

  function ensureFreeGifts() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var updates = {};
        var adds = [];
        var hasFreeKarabiner = false;
        var hasFreeKordel = false;
        var undaQty = 0;

        (cart.items || []).forEach(function (line) {
          var props = line.properties || {};
          var paidId = String(line.variant_id);
          var freeId = PAID_GIFT_TO_FREE[paidId];

          if (props.__kaching_bundles) {
            try {
              var meta = JSON.parse(props.__kaching_bundles);
              if (meta && meta.main === true) undaQty = line.quantity;
            } catch (e) {}
          }

          if (paidId === FREE_KARABINER) {
            hasFreeKarabiner = true;
            if (line.quantity > 1) updates[line.key] = 1;
          }
          if (paidId === FREE_KORDEL) {
            hasFreeKordel = true;
            if (line.quantity > 1) updates[line.key] = 1;
          }

          // Drop charged Kaching gift lines (paid accessory SKUs).
          if (freeId) {
            var isGift = false;
            if (props.__kaching_bundles) {
              try {
                var gmeta = JSON.parse(props.__kaching_bundles);
                isGift = !(gmeta && gmeta.main === true);
              } catch (e2) {
                isGift = true;
              }
            } else if (undaQty >= 2) {
              isGift = true;
            }
            if (isGift) updates[line.key] = 0;
          }
        });

        var needKarabiner = undaQty >= 2;
        var needKordel = undaQty >= 3;

        // Remove Gratis Kordel when below the 3-bottle threshold (e.g. Favorite = 2).
        if (!needKordel && hasFreeKordel) {
          (cart.items || []).forEach(function (line) {
            if (String(line.variant_id) === FREE_KORDEL) updates[line.key] = 0;
          });
          hasFreeKordel = false;
        }
        if (!needKarabiner && hasFreeKarabiner) {
          (cart.items || []).forEach(function (line) {
            if (String(line.variant_id) === FREE_KARABINER) updates[line.key] = 0;
          });
          hasFreeKarabiner = false;
        }

        if (needKarabiner && !hasFreeKarabiner) {
          adds.push({ id: FREE_KARABINER, quantity: 1, properties: { _unda_free_gift: 'karabiner' } });
        }
        if (needKordel && !hasFreeKordel) {
          adds.push({ id: FREE_KORDEL, quantity: 1, properties: { _unda_free_gift: 'kordel' } });
        }

        var keys = Object.keys(updates);
        var chain = Promise.resolve();
        if (keys.length) {
          chain = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }
        return chain
          .then(function () {
            if (!adds.length) return null;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: adds })
            });
          })
          .then(function (res) {
            if (!res && !keys.length) return;
            if (/\/cart\/?$/.test(location.pathname) && (keys.length || adds.length)) {
              location.reload();
            }
          });
      })
      .catch(function () {});
  }

  function isEnglish() {
    var lang =
      (window.Shopify && Shopify.locale) ||
      document.documentElement.lang ||
      '';
    return String(lang).toLowerCase().indexOf('en') === 0;
  }

  // Short locale titles: DE site = DE only, EN site = EN only.
  var TITLES = {
    de: {
      single: 'Einzel',
      favorite: 'Beliebtes Duo',
      trio: 'Trio',
      four: '4er-Set',
      five: '5er-Set',
      block: 'BUNDLE & SPAREN'
    },
    en: {
      single: 'Single',
      favorite: 'Favorite Duo',
      trio: 'Trio',
      four: '4-Pack',
      five: '5-Pack',
      block: 'BUNDLE & SAVE'
    }
  };

  function barKind(titleText) {
    var t = String(titleText || '').trim();
    if (/^(Single|Einzel)\b/i.test(t)) return 'single';
    if (/Favorite|Beliebtes Duo|Lieblings/i.test(t)) return 'favorite';
    if (/^Trio\b/i.test(t) || /^3er/i.test(t)) return 'trio';
    if (/^4(er|-Pack|-pack)/i.test(t) || /Family of 4/i.test(t)) return 'four';
    if (/^5(er|-Pack|-pack)/i.test(t) || /Family of 5/i.test(t)) return 'five';
    return null;
  }

  function localizeText(text, en) {
    if (!text) return text;
    var out = text;
    if (en) {
      out = out
        .replace(/\bBUNDLE\s*&\s*SPAREN\b/gi, 'BUNDLE & SAVE')
        .replace(/\bSpare\b/g, 'Save')
        .replace(/\bSPARE\b/g, 'SAVE')
        .replace(/\bFlaschen\b/g, 'Bottles')
        .replace(/\bFlasche\b/g, 'Bottle')
        .replace(/\bKarabiner\b/g, 'Carabiner')
        .replace(/\bKordel\b/g, 'Cord')
        .replace(/\bGratis\b/g, 'Free')
        .replace(/\b4er-Set\b/gi, '4-Pack')
        .replace(/\b5er-Set\b/gi, '5-Pack');
    } else {
      out = out
        .replace(/\bBUNDLE\s*&\s*SAVE\b/gi, 'BUNDLE & SPAREN')
        .replace(/\bSave\b/g, 'Spare')
        .replace(/\bSAVE\b/g, 'SPARE')
        .replace(/\bBottles\b/g, 'Flaschen')
        .replace(/\bBottle\b/g, 'Flasche')
        .replace(/\bCarabiners?\b/gi, 'Karabiner')
        .replace(/\bCords?\b/gi, 'Kordel')
        .replace(/\bFree\b/g, 'Gratis')
        .replace(/\b4-Pack\b/gi, '4er-Set')
        .replace(/\b5-Pack\b/gi, '5er-Set');
    }
    return out;
  }

  var KARABINER_PRODUCT_PATH = '/products/karabiner-in-s-form';
  var KARABINER_VARIANT = '52736582222160';
  var KARABINER_IMAGE =
    'https://cdn.shopify.com/s/files/1/0643/7994/5203/files/S-Karabiner_Schwarz.jpg?v=1773265667';

  function isFavoriteBar(bar) {
    if (!bar) return false;
    if (bar.getAttribute('data-deal-bar-id') === 'dUo2') return true;
    var title = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
    return barKind(title) === 'favorite';
  }

  // Duo still ships a Kordel gift SKU/image from Kaching — rewrite to Karabiner.
  function fixFavoriteGiftMedia(bar, en) {
    if (!isFavoriteBar(bar)) return;
    var gifts = bar.querySelectorAll('.kaching-bundles__free-gift');
    Array.prototype.forEach.call(gifts, function (gift, index) {
      // Keep one gift chip; drop extras (Kaching sometimes stacks both).
      if (index > 0) {
        gift.style.display = 'none';
        return;
      }
      var link = gift.querySelector('a.kaching-bundles__free-gift__link, a[href*="kordel"], a[href*="karabiner"]');
      if (link) {
        link.href = KARABINER_PRODUCT_PATH + '?variant=' + KARABINER_VARIANT;
      }
      var img = gift.querySelector('img.kaching-bundles__free-gift__image, img');
      if (img) {
        img.src = KARABINER_IMAGE;
        img.srcset = '';
        img.alt = en ? 'Carabiner' : 'Karabiner';
      }
      var text = gift.querySelector('.kaching-bundles__free-gift__text');
      if (text) text.textContent = en ? '+ Free Carabiner' : '+ Gratis Karabiner';
    });

    // Also scrub any leftover Kordel/Cord wording on the favorite bar.
    Array.prototype.forEach.call(
      bar.querySelectorAll('.kaching-bundles__free-gift__text, .kaching-bundles__bar-label, .kaching-bundles__bar-subtitle'),
      function (el) {
        var t = el.textContent || '';
        if (!/Kordel|Cord/i.test(t)) return;
        el.textContent = t
          .replace(/\s*\+\s*Kordel/gi, '')
          .replace(/\s*\+\s*Cord/gi, '')
          .replace(/Karabiner\s*\+/i, 'Karabiner')
          .replace(/Carabiner\s*\+/i, 'Carabiner')
          .replace(/Gratis:\s*Karabiner.*/i, en ? '+ Free Carabiner' : '+ Gratis Karabiner')
          .trim();
      }
    );
  }

  function ensureMixMatchHint(bar, en) {
    if (!bar || bar.querySelector('.unda-mix-match-hint')) return;
    var variants = bar.querySelector('.kaching-bundles__bar-variants');
    if (!variants) return;
    var hint = document.createElement('p');
    hint.className = 'unda-mix-match-hint';
    hint.textContent = en ? 'Mix and Match Bundle' : 'Mix & Match – Farben kombinieren';
    var names = variants.querySelector('.kaching-bundles__bar-variant-names');
    if (names && names.parentNode === variants) {
      names.insertAdjacentElement('afterend', hint);
    } else {
      variants.insertAdjacentElement('afterbegin', hint);
    }
  }

  function patchBundleLocale() {
    var en = isEnglish();
    var map = en ? TITLES.en : TITLES.de;
    var root =
      document.querySelector('.unda-pdp-hero__bundles') ||
      document.querySelector('.kaching-bundles') ||
      document;

    var blockTitle = root.querySelector(
      '.kaching-bundles__title, .kaching-bundles__block-title, [class*="kaching-bundles"] [class*="block-title"]'
    );
    if (blockTitle && /BUNDLE/i.test(blockTitle.textContent || '')) {
      blockTitle.textContent = map.block;
    }

    var bars = root.querySelectorAll('.kaching-bundles__bar');
    Array.prototype.forEach.call(bars, function (bar) {
      var titleEl = bar.querySelector('.kaching-bundles__bar-title');
      if (!titleEl) return;
      var kind = isFavoriteBar(bar) ? 'favorite' : barKind(titleEl.textContent);
      if (kind && map[kind]) titleEl.textContent = map[kind];

      var label = bar.querySelector('.kaching-bundles__bar-label');
      var subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (label) label.textContent = localizeText(label.textContent, en);
      if (subtitle) subtitle.textContent = localizeText(subtitle.textContent, en);

      // Favorite / Beliebtes Duo: Karabiner only (no Kordel) — client incentives.
      if (kind === 'favorite') {
        if (subtitle) {
          subtitle.textContent = en ? '2 Bottles + Carabiner' : '2 Flaschen + Karabiner';
        }
        if (label) {
          label.textContent = en
            ? 'Save 5,90 € · 11% · +Carabiner'
            : 'Spare 5,90 € · 11% · +Karabiner';
        }
        fixFavoriteGiftMedia(bar, en);
        ensureMixMatchHint(bar, en);
      } else {
        Array.prototype.forEach.call(
          bar.querySelectorAll(
            '.kaching-bundles__free-gift__text, .kaching-bundles__free-gift-summary .kaching-bundles__free-gift__text'
          ),
          function (el) {
            el.textContent = localizeText(el.textContent, en);
          }
        );
      }
    });
  }

  // Pre-select Favorite / Beliebtes Duo once Kaching hydrates (was Trio).
  // Retry briefly — Kaching often re-applies its own default after first paint.
  var defaultSelectStartedAt = Date.now();
  function selectFavoriteDefault() {
    if (window.__undaFavoriteDefaultDone) return;
    if (Date.now() - defaultSelectStartedAt > 8000) {
      window.__undaFavoriteDefaultDone = true;
      return;
    }
    var root =
      document.querySelector('.unda-pdp-hero__bundles') ||
      document.querySelector('.kaching-bundles');
    if (!root) return;
    var bars = root.querySelectorAll('.kaching-bundles__bar');
    if (!bars.length) return;

    var favorite = null;
    var selected = null;
    Array.prototype.forEach.call(bars, function (bar) {
      var title = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
      var kind = barKind(title);
      if (kind === 'favorite') favorite = bar;
      if (
        bar.classList.contains('kaching-bundles__bar--selected') ||
        bar.classList.contains('is-selected')
      ) {
        selected = bar;
      }
    });
    if (!favorite) return;
    if (selected === favorite) {
      window.__undaFavoriteDefaultDone = true;
      return;
    }
    try {
      var clickTarget =
        favorite.querySelector('input[type="radio"]') ||
        favorite.querySelector('[role="radio"]') ||
        favorite.querySelector('.kaching-bundles__bar-header') ||
        favorite;
      clickTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      if (typeof clickTarget.click === 'function') clickTarget.click();
    } catch (e) {}
  }

  function runBundleUiPatches() {
    patchBundleLocale();
    selectFavoriteDefault();
  }

  installFetchPatch();
  installFormPatch();
  setTimeout(ensureFreeGifts, 800);
  [600, 1200, 2000, 3000, 4500, 6500].forEach(function (ms) {
    setTimeout(runBundleUiPatches, ms);
  });
  setInterval(function () {
    patchBundleLocale();
    if (!window.__undaFavoriteDefaultDone) selectFavoriteDefault();
  }, 1500);
  window.undaEnsureFreeGifts = ensureFreeGifts;
})();
